import React, { useEffect } from 'react'
import { EventResult } from '../../utils/types'
import { configs } from '../../configs'
import { HttpStatusCode } from 'axios/index'

const ReigniteEventHub = ({
  onMessage,
  updateIsLoading,
  params
}: {
  onMessage: (parsed: { data: EventResult[], status: HttpStatusCode }) => void
  updateIsLoading: (value: boolean) => void
  params: {
    ctliveEventId: number
    ctliveRaceId?: number
    athlinksEventId: number
    eventCourseId?: number
    divisionId?: number
    from: number
    limit: number
    asOf: number
  }
}) => {
  const {
    ctliveEventId,
    ctliveRaceId,
    athlinksEventId,
    eventCourseId,
    divisionId,
    from,
    limit,
    asOf,
  } = params
  const encodedUrl = encodeURIComponent(
    `${configs.resultsApiUrl}/event/${athlinksEventId}?eventCourseId=${eventCourseId || ''}&divisionId=${divisionId || ''}&from=${from}&limit=${limit}`
  )
  useEffect(() => {
    updateIsLoading(true)
    const eventSource = new EventSource(`${process.env.REACT_APP_REIGNITE_SSE_URL}/hub/azp/ctlive/event/${ctliveEventId}${ctliveRaceId ? `/race/${ctliveRaceId}` : ''}${divisionId && ctliveRaceId ? `/bracket/${divisionId}` : ''}?url=${encodedUrl}`)
    eventSource.addEventListener('multicast', (event) => {
      const parsed = JSON.parse(event.data)
      console.info('Event Hub received:', parsed)
      onMessage(parsed)
      updateIsLoading(false)
    })

    eventSource.addEventListener('error', (error) => {
      console.error('Error with Event Hub:', error)
      updateIsLoading(false)
    })

    return () => {
      eventSource.close()
    }
  }, [
    asOf,
    ctliveEventId,
    ctliveRaceId,
    divisionId,
    encodedUrl,
    onMessage,
    updateIsLoading,
  ])

  return (<div />)
}

export default ReigniteEventHub
